import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface RouterLinkWithHrefProps extends LinkProps {
  href: string;
}

const RouterLink = React.forwardRef<any, RouterLinkWithHrefProps>(
  (props, ref) => (
    <Link {...props} to={props.href ?? ''} ref={ref}>
      {props.children}
    </Link>
  ),
);

export default function (props: ButtonProps) {
  return <Button {...props} LinkComponent={RouterLink} />;
}
